import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {IBreadcrumbsItem} from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import {NewsService} from '../../../../shared-services/news.service';
import {IComplexNews, INewsDetailInterface, NewsItem} from '../../../../interfaces/inews-detail.interface';
import { isPlatformServer } from '@angular/common';
import {SEOService} from "../../../../pages/shared/seoService";

@Component({
  selector: 'app-news-page',
  templateUrl: './news-page.component.html',
  styleUrl: './news-page.component.scss'
})
export class NewsPageComponent implements OnInit, AfterViewInit {
  slug = '';
  newsItem: NewsItem | null = null;
  complexNews: IComplexNews | null = null;
  breadcrumbs: IBreadcrumbsItem[] =
  [
    { title: 'НДВ Супермаркет Недвижимости', href: '/',},
    { title: 'Пресс-центр', href: '/press-centr',},
    { title: '', routerLink: '',},
  ];

  constructor(
    private route: ActivatedRoute,
    private newsService: NewsService,
    private renderer: Renderer2,
    private seoService: SEOService,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {}

  ngOnInit(): void {
    // Subscribe to the route parameters to get the slug and id
    this.route.params.subscribe(params => {
      const regex = /(?<=-)\d+$/;
      const matched = params['slug'].match(regex);
      if (matched && matched.length > 0) {
        this.slug = matched[0];
        this.fetchOneNews(this.slug);
      }
    });
  }

  fetchOneNews(id: string) {
    this.newsService.getNewsById(id)
      .subscribe((res: INewsDetailInterface)=> {
        this.newsItem = res.data.item;
        this.complexNews = res.data.complex;

        this.breadcrumbs[2].title = this.newsItem ? this.newsItem.title : '';

        if (this.newsItem) {
          const rawContent = this.newsItem.content || '';
          // удаляем HTML и спецсимволы
          const textContent = rawContent.replace(/<[^>]+>/g, '').replace(/&[^;\s]+;/g, ' ');

          // Обрезаем до точки или до 200 символов
          let shortDescription = textContent.split('.')[0]?.trim() || textContent.slice(0, 200).trim();
          if (shortDescription.length > 200) {
            shortDescription = shortDescription.slice(0, 197).trim() + '...';
          }

          const title = `${this.newsItem.title} | Новости НДВ`;
          const description = `Новости агентства НДВ! ${shortDescription}`;

          this.seoService.updateTitle(title);
          this.seoService.updateDescription(description);
        }
      });
  }

  ngAfterViewInit() {
    if (!isPlatformServer(this.platformId)) {
      const script = this.renderer.createElement('script');
      script.src = 'https://usocial.pro/usocial/usocial.js?uid=d856be4972f55262&v=6.1.5';
      script.async = true;
      script.charset = 'utf-8';
      this.renderer.appendChild(document.body, script);
    }
  }
}

